import {Share} from 'a-utils';
type ShareType = keyof typeof Share;
import { gsap } from 'gsap';
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
gsap.registerPlugin(MorphSVGPlugin)

function getRandomArbitrary(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const ICONS: { [key in ShareType]?: string } = {
    'vk': 'M19.4,29.5h2.1c0,0,0.6,0,1-0.4c0.3-0.3,0.3-0.8,0.3-0.8s0-2.7,1.3-3.1c1.3-0.4,2.8,2.6,4.6,3.7 c1.3,0.8,2.2,0.7,2.2,0.7h4.5c0,0,2.4-0.1,1.3-2c-0.1-0.1-0.7-1.4-3.4-3.8c-2.8-2.6-2.5-2.2,1-6.6c2.1-2.7,2.9-4.4,2.7-5.1 c-0.3-0.7-1.8-0.5-1.8-0.5h-5.2c0,0-0.4,0-0.7,0.1c-0.3,0.1-0.4,0.5-0.4,0.5s-0.8,2.2-1.8,4c-2.2,3.9-3.2,4-3.5,3.7 c-0.8-0.5-0.7-2.2-0.7-3.4c0-3.7,0.6-5.2-1.1-5.6c-0.6-0.1-1-0.3-2.4-0.3c-1.8,0-3.4,0-4.2,0.4c-0.6,0.3-1,1-0.7,1 c0.3,0,1.1,0.1,1.5,0.7c0.6,0.7,0.6,2.3,0.6,2.3s0.3,4.4-0.7,4.8c-0.7,0.4-1.7-0.4-3.6-3.8c-1-1.8-1.8-3.7-1.8-3.7s-0.1-0.4-0.4-0.5 C9.6,11.3,9,11.3,9,11.3H4.1c0,0-0.7,0-1,0.3c-0.3,0.3,0,0.8,0,0.8s3.8,8.7,8.1,13.1C14.9,29.8,19.4,29.5,19.4,29.5z',
    'fb': 'M16.5,15.5H13V20h3.5v13.5h5.8V20h4.2l0.4-4.5h-4.7v-1.9c0-1.1,0.2-1.5,1.3-1.5H27V6.5h-4.4 c-4.2,0-6.1,1.8-6.1,5.2V15.5z',
    'tw': 'M33.5,11.6c-1,0.4-2.1,0.7-3.2,0.9c1.1-0.7,2-1.8,2.4-3.1c-1.1,0.6-2.3,1.1-3.5,1.3c-1-1.1-2.5-1.8-4-1.8c-3.6,0-6.2,3.3-5.4,6.8c-4.6-0.2-8.7-2.4-11.4-5.8c-1.5,2.5-0.8,5.8,1.7,7.4c-0.9,0-1.8-0.3-2.5-0.7c-0.1,2.6,1.8,5,4.4,5.5c-0.8,0.2-1.6,0.3-2.5,0.1c0.7,2.2,2.7,3.8,5.2,3.9c-2.3,1.8-5.3,2.6-8.2,2.3C9,30.1,11.9,31,15,31c10.3,0,16.1-8.7,15.7-16.5C31.8,13.7,32.8,12.7,33.5,11.6z',
};

const CLASS_NAME = 'sh-button';
export class ShareElement extends HTMLElement{
    public _svgHover: any;
    private _tween?: gsap.core.Tween;

    constructor() {
        super();

        const dataShare = this.dataset.share;
        if (!dataShare) throw new Error('share-view: Missing data-share');

        const href = window.location.href;
        const types = dataShare.split(',') as (keyof typeof Share)[];


        types.forEach((type) => {
            const button = document.createElement('button');
            button.className = `${CLASS_NAME} ${type}`;

            const icon = ICONS[type];
            if (icon) button.innerHTML = `
              <svg class="shareicon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path d="${icon}"/></svg>
              <svg class="btnbg" preserveAspectRatio="none" viewBox="0 0 292 172" xmlns="http://www.w3.org/2000/svg">
                <path class="svg-morf" id="btn-morf" d="M14,36h264v59H14V36z"/>
              </svg>`

            setTimeout(() => {
                this._svgHover = this.querySelector('.btn-morf')
            })

            button.addEventListener('click', (e) => {
                e.preventDefault();
                Share[type](href);
            })
            this.appendChild(button);
        })

    }
    connectedCallback() {
        this.addEventListener('mouseenter', this._onHover);
        this.addEventListener('mouseleave', this._onBlur);
    }
    disconnectedCallback() {
        this.removeEventListener('mouseenter', this._onHover);
        this.removeEventListener('mouseleave', this._onBlur);
    }


    _onHover() {
        let numb = getRandomArbitrary(1,5);
        this._tween = gsap.to(this._svgHover, {morphSVG: `#btn-finish-${numb}`, duration: .5})
    }
    _onBlur() {
        this._tween = gsap.to(this._svgHover, {morphSVG: '#btn-start', duration: .5})
    }

}
window.customElements.define('share-view', ShareElement);
